import { FETCH_ACC_BU_NUDGE_FAILURE, FETCH_ACC_BU_NUDGE_REQUEST, FETCH_ACC_BU_NUDGE_SUCCESS, FETCH_ACC_BU_VERSION_NUDGE_SUCCESS } from "../actions/accountBuNudgesActions";
import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";

  const initialState = {
    acc_bu_nudges: [],
    acc_bu_version:"",
    acc_bu_nudges_loading: true,
    acc_bu_nudges_error: null,
  };
  
  const accBuNudgeReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ACC_BU_NUDGE_REQUEST:
        return { ...state, acc_bu_nudges_loading: true , payload: action.payload};
      case FETCH_ACC_BU_NUDGE_SUCCESS:
        return { ...state, acc_bu_nudges_loading: false, acc_bu_nudges: action.payload };
      case FETCH_ACC_BU_VERSION_NUDGE_SUCCESS:
        return {...state, acc_bu_version:action.payload }  
      case FETCH_ACC_BU_NUDGE_FAILURE:
        return { ...state, acc_bu_nudges_loading: false, acc_bu_nudges_error: action.payload };
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
        return { ...state, acc_bu_nudges_loading: true, acc_bu_nudges: [] };
      default:
        return state;
    }
  };
  
  export default accBuNudgeReducer;
  